/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';
/*eslint no-underscore-dangle:0*/

var id = 'pageMain',
    Page = require('stb-component-page'),
    page = new Page({$node: document.getElementById(id)}),
    keys = require('stb-keys'),
    Panel = require('spa-component-panel'),
    Button = require('stb-component-button'),
    ModalBox = require('stb-component-modal'),

    // game modules
    GameManager = require('../game/game_manager'),
    HTMLActuator = require('../game/html_actuator'),
    LocalStorageManager = require('../game/local_storage_manager'),

    // app components
    game,

    gameBoard = new Panel({
        $node: document.getElementById('game'),
        focusable: true
    }),

    modalLost = new ModalBox({
        visible: false,
        className: 'gameModal',
        events: {
            show: function () {
                this.children[1].focus();
            },
            hide: function () {
                gameBoard.focus();
            }
        },
        children: [
            new Panel({
                className: 'modalTitle'
            }),
            new Button({
                value: 'Restart',
                events: {
                    keydown: function ( event ) {
                        Button.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.right:
                                modalLost.children[2].focus();
                                break;
                            case keys.exit:
                            case keys.back:
                                modalLost.hide();
                                game.restart();
                                break;
                        }
                    },
                    click: function () {
                        modalLost.hide();
                        game.restart();
                    }
                }
            }),
            new Button({
                value: 'exit',
                events: {
                    keydown: function ( event ) {
                        Button.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.left:
                                modalLost.children[1].focus();
                                break;
                            case keys.exit:
                            case keys.back:
                                modalLost.hide();
                                game.restart();
                                break;
                        }
                    },
                    click: function () {
                        core.call('exit');
                    }
                }
            })
        ]
    }),
    modalWin = new ModalBox({
        visible: false,
        className: 'gameModal',
        events: {
            show: function () {
                modalWin.children[1].focus();
            },
            hide: function () {
                gameBoard.focus();
            }
        },
        children: [
            new Panel({
                className: 'modalTitle'
            }),
            new Button({
                value: 'Continue',
                events: {
                    keydown: function ( event ) {
                        Button.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.right:
                                modalWin.children[2].focus();
                                break;
                            case keys.exit:
                            case keys.back:
                                modalWin.hide();
                                game._keepPlaying();
                                break;
                        }
                    },
                    click: function () {
                        modalWin.hide();
                        game._keepPlaying();
                    }
                }
            }),
            new Button({
                value: 'Restart',
                events: {
                    keydown: function ( event ) {
                        Button.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.left:
                                modalWin.children[1].focus();
                                break;
                            case keys.exit:
                            case keys.back:
                                modalWin.hide();
                                game._keepPlaying();
                                break;
                        }
                    },
                    click: function () {
                        modalWin.hide();
                        game.restart();
                    }
                }
            })
        ]
    }),


    // nodes
    control = {
        $left: document.getElementById('leftKey'),
        $right: document.getElementById('rightKey'),
        $top: document.getElementById('topKey'),
        $bot: document.getElementById('botKey'),
        last: null,
        timer: 0
    };


// page.add(modalExit);
page.add(modalLost);
page.add(modalWin);
// modalExit.children[0].$node.innerText = 'Are you sure you want to exit?';
modalLost.children[0].$node.innerText = 'Game over! :(';
modalWin.children[0].$node.innerText = 'You win :)';

page.addListener('show', function () {
    //requestAnimationFrame(function () {
    window.game = game = new GameManager(4, HTMLActuator, LocalStorageManager);

    //});

    gameBoard.focus();
    game.actuator.addListeners({
        lose: function () {
            modalLost.show();
        },
        win: function () {
            modalWin.show();
        }
    });

});


gameBoard.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.down:
        case keys.up:
        case keys.left:
        case keys.right:
            game.move(event.code);
            animateControl(event.code); //eslint-disable-line
            break;
        case keys.f2:
            game.restart();
            break;
        case keys.back:
            exit(); //eslint-disable-line
            break;
    }
});


page.addListener('unload', function () {
    game.storageManager._saveSate(game.serialize());
});

/**
 * Animate control keydowns.
 *
 * @param {number} direction - direction of pressed key
 */
function animateControl ( direction ) {
    if ( control.last ) {
        control.last.classList.remove('click');
    }
    clearTimeout(control.timer);

    switch ( direction ) {
        case keys.left:
            control.last = control.$left;
            break;
        case keys.right:
            control.last = control.$right;
            break;
        case keys.up:
            control.last = control.$top;
            break;
        case keys.down:
            control.last = control.$bot;
            break;
    }
    control.last.classList.add('click');

    control.timer = setTimeout(function () {
        control.last.classList.remove('click');
    }, 100);
}

function exit (  ) {
    core.notify({
        title: 'Do you want to exit?',
        icon: 'alert',
        type: '',
        buttons: [
            {
                value: 'Exit',
                click: function () {
                    core.call('exit');
                }
            },
            {
                value: 'Cancel',
                click: function () { /**/ }
            }
        ],
        timeout: 5000
    });

}


// public
module.exports = page;
